// @flow
import * as React from 'react';
import { useEffect, useState } from 'react'
import { getCSRFToken } from "../utils/http"
import { fetchWhitelist } from "../actions/shipping"
import { useDispatch, useSelector } from 'react-redux';
let isLoading=false

export  default  (): any => {
  const dispatch = useDispatch();
  const whitelist = useSelector((state) => state.global.shippingProfileWhiteList);
  const shippingProfileWhiteListIsBeingFetched = useSelector((state) => state.global.shippingProfileWhiteListIsBeingFetched);
  
  useEffect(() => {

    if (whitelist==="UNSET" && shippingProfileWhiteListIsBeingFetched===false&&isLoading==false) {
      isLoading=true
      dispatch(fetchWhitelist(dispatch,()=>{isLoading=false}))
    }
  }, [whitelist, shippingProfileWhiteListIsBeingFetched])
  return { whitelist };
};
